import type { PropsWithChildren } from "react";
import React from "react";
import * as styles from "./QuizLayoutV3.css";

export const QuizLayoutV3: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.quizLayout} data-testid="QuizLayoutV3">
      <div className={styles.layoutWrapper}>
        <div className={styles.quizPagesWrapper}>{children}</div>
      </div>
    </div>
  );
};
